import { Grid } from '@mui/material';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import InputNumberItem from 'components/Input/InputNumber';
import { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import { RouterDOM } from 'utilities/utilities';

const AllInput = () => {

    //#region Hook
    const Router = RouterDOM();

    // #endregion

    //#region State / Usememo


    // #endregion

    //#region Form
    const form = useForm({
        shouldUnregister: true,
        shouldFocusError: true,
        mode: "all",
    });

    // #endregion

    //#region Function / useCallBack

    const handleSubmitError = useCallback((value) => {
        form.setValue("InputNumberItem", 0)
    }, [])

    const gotoBack = () => {
        Router.GoToPage("#")
    }

    const handleSubmitForm = (value) => {


    }

    // #endregion


    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} >
                    {/* Form */}
                    <FormProvider {...form}>
                        <Grid container spacing={2}>
                            {/* <Grid item xs={12} >
                                <AutoCompleteItem
                                    label={"AutoCompleteItem"}
                                    name={'AutoCompleteItem'}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CheckBoxItem
                                    label={"CheckBoxItem"}
                                    name={'CheckBoxItem'}
                                    required
                                    options={[
                                        { label: "label True", value: "1" },
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CheckBoxListItem
                                    label={"CheckBoxListItem"}
                                    name={'CheckBoxListItem'}
                                    required
                                    options={[
                                        { label: "label 1", value: "1" },
                                        { label: "label 2", value: "2" },
                                        { label: "label 3", value: "3" },
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DatePickerItem
                                    label={"DatePickerItem"}
                                    name={'DatePickerItem'}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DateRangePickerItem
                                    label={"DateRangePickerItem"}
                                    name={'DateRangePickerItem'}
                                    labelStart='start'
                                    labelEnd='end'
                                    required
                                />
                            </Grid><Grid item xs={12} md={6}>
                                <MonthYearRangePickerItem
                                    label={"MonthYearRangePickerItem"}
                                    name={'MonthYearRangePickerItem'}
                                    labelStart='start'
                                    labelEnd='end'
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <QuarterPickerItem
                                    label={"QuarterPickerItem"}
                                    name={'QuarterPickerItem'}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <QuarterRangePickerItem
                                    label={"QuarterRangePickerItem"}
                                    name={'QuarterRangePickerItem'}
                                    labelStart='start'
                                    labelEnd='end'
                                    required
                                />
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                                <InputNumberItem
                                    label={"InputNumberItem"}
                                    name={'InputNumberItem'}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputNumberItem
                                    label={"NumberScientific"}
                                    name={'NumberScientific'}
                                    IsAllowScientific
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputNumberItem
                                    label={"minInputNumberItem"}
                                    name={'minInputNumberItem'}
                                    required
                                    min={5}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputNumberItem
                                    label={"maxInputNumberItem"}
                                    name={'maxInputNumberItem'}
                                    required
                                    max={100}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputNumberItem
                                    label={"minmaxInputNumberItem"}
                                    name={'minmaxInputNumberItem'}
                                    required
                                    min={5}
                                    max={100}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                                <RadioListItem
                                    label={"RadioListItem"}
                                    name={'RadioListItem'}
                                    required
                                    options={[
                                        { label: "label 1", value: "1" },
                                        { label: "label 2", value: "2" },
                                        { label: "label 3", value: "3" },
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextBoxItem
                                    label={"TextBoxItem"}
                                    name={'TextBoxItem'}
                                    maxLength={500}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextAreaItem
                                    label={"TextAreaItem"}
                                    name={'TextAreaItem'}
                                    maxLength={500}
                                    required
                                />
                            </Grid> */}
                        </Grid>
                    </FormProvider>
                </Grid>
                <Grid item xs={12} >
                    {/* Button */}
                    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"start"}>
                        <Grid item>
                            <BtnBack id={"btnback-temp-email"} onClick={() => gotoBack()} />
                        </Grid>
                        <Grid item>
                            <BtnSave id={"btnsave-temp-email"} onClick={form.handleSubmit(handleSubmitForm, handleSubmitError)} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AllInput
